import React from "react"
import ActionWrapper from "containers/ActionWrapper"
import {
  formatDateRange,
  getAbbrFromState,
  getGoogleMapsAddress,
} from "utils/camper-utils"

import {
  BriefDescription,
  FullDescription,
  Header,
  Segment,
  CampInformation,
  Title,
  Body,
  Info,
  InfoColumn,
  InfoDetail,
  InfoTitle,
  BulletItem,
  CampExpertise,
  CampSpecialty,
  StyledLink,
} from "./index"

import style from "utils/style"

class CampProfileLoaded extends React.Component {
  renderCampSpecialties = specialties => (
    <Body wrap>
      {specialties.map(specialty => (
        <BulletItem key={specialty.id}>{specialty.attributes.name}</BulletItem>
      ))}
    </Body>
  )

  renderCampExpertises = expertises => (
    <Body wrap>
      {expertises.map(expertise => (
        <BulletItem key={expertise.id}>{expertise.attributes.name}</BulletItem>
      ))}
    </Body>
  )

  render() {
    let camp = this.props.data.data
    let campAttributes = camp.attributes

    let expertises = this.props.data.included
      ? this.props.data.included.filter(item => item.type === "camp-expertises")
      : []

    let specialties = this.props.data.included
      ? this.props.data.included.filter(
          item => item.type === "camp-specialties"
        )
      : []

    return (
      <ActionWrapper title={campAttributes.name}>
        <Header>
          <BriefDescription>
            {campAttributes["description-brief-campers"]}
          </BriefDescription>
          <FullDescription>
            {campAttributes["description-full-campers"]}
          </FullDescription>
        </Header>
        <Segment backgroundColor={style.colors.lightMintGreen}>
          <CampInformation>
            <Title>Camp Information</Title>
            <Body>
              <InfoColumn>
                <Info>
                  <InfoTitle>Session Dates</InfoTitle>
                  <InfoDetail>
                    {formatDateRange(
                      campAttributes["campers-session-start-date"],
                      campAttributes["campers-session-end-date"]
                    )}
                  </InfoDetail>
                </Info>
                <Info>
                  <InfoTitle>Address</InfoTitle>

                  <InfoDetail>{campAttributes["camp-address"]}</InfoDetail>
                  {campAttributes["camp-address-2"] && (
                    <InfoDetail>{campAttributes["camp-address-2"]}</InfoDetail>
                  )}
                  <InfoDetail>
                    {campAttributes["camp-city"] +
                      ", " +
                      getAbbrFromState(campAttributes["camp-state"]) +
                      " " +
                      campAttributes["camp-zip"]}
                  </InfoDetail>
                  <InfoDetail>{campAttributes["camp-country"]}</InfoDetail>

                  <StyledLink
                    href={`https://maps.google.com/maps?q=${getGoogleMapsAddress(
                      campAttributes
                    )}`}
                  >
                    View in Google Maps
                  </StyledLink>
                </Info>
                <Info>
                  <InfoTitle>Dates and rates</InfoTitle>
                  <InfoDetail>{campAttributes["dates-and-rates"]}</InfoDetail>
                </Info>
                <Info>
                  <InfoTitle>Phone and fax</InfoTitle>
                  <InfoDetail>Phone: {campAttributes["camp-phone"]}</InfoDetail>
                  {campAttributes["camp-fax"] !== "" && (
                    <InfoDetail>Fax: {campAttributes["camp-fax"]}</InfoDetail>
                  )}
                </Info>
              </InfoColumn>
              <InfoColumn>
                <Info>
                  <InfoTitle>Camp website & email</InfoTitle>
                  <InfoDetail>
                    Website:{" "}
                    <StyledLink href={campAttributes.website}>
                      {campAttributes.website}
                    </StyledLink>
                  </InfoDetail>

                  <InfoDetail>
                    Email:{" "}
                    <StyledLink
                      href={`mailto:${campAttributes["campers-email"]}`}
                    >
                      {campAttributes["campers-email"]}
                    </StyledLink>
                  </InfoDetail>
                </Info>
                <Info>
                  <InfoTitle>Camp social</InfoTitle>
                  {campAttributes.facebook &&
                  campAttributes.facebook !== "" && (
                    <InfoDetail>
                      Facebook:{" "}
                      <StyledLink href={campAttributes.facebook}>
                        {campAttributes.facebook}
                      </StyledLink>
                    </InfoDetail>
                  )}

                  {campAttributes.twitter &&
                  campAttributes.twitter !== "" && (
                    <InfoDetail>
                      Twitter:{" "}
                      <StyledLink href={campAttributes.twitter}>
                        {campAttributes.twitter}
                      </StyledLink>
                    </InfoDetail>
                  )}

                  {campAttributes.instagram &&
                  campAttributes.instagram !== "" && (
                    <InfoDetail>
                      Instagram:{" "}
                      <StyledLink href={campAttributes.instagram}>
                        {campAttributes.instagram}
                      </StyledLink>
                    </InfoDetail>
                  )}

                  {campAttributes.youtube &&
                  campAttributes.youtube !== "" && (
                    <InfoDetail>
                      YouTube:{" "}
                      <StyledLink href={campAttributes.youtube}>
                        {campAttributes.youtube}
                      </StyledLink>
                    </InfoDetail>
                  )}

                  {campAttributes.skype &&
                  campAttributes.skype !== "" && (
                    <InfoDetail>
                      Skype:{" "}
                      <StyledLink href={campAttributes.skype}>
                        {campAttributes.skype}
                      </StyledLink>
                    </InfoDetail>
                  )}
                </Info>
              </InfoColumn>
              <InfoColumn>
                <Info>
                  <InfoTitle>Day camp</InfoTitle>
                  <BulletItem>
                    {campAttributes["camp-type-day"] ? "Yes" : "No"}
                  </BulletItem>
                </Info>
                <Info>
                  <InfoTitle>Sleep away camp</InfoTitle>
                  <BulletItem>
                    {campAttributes["camp-type-sleep-away"] ? "Yes" : "No"}
                  </BulletItem>
                </Info>
                <Info>
                  <InfoTitle>Camp accreditation</InfoTitle>
                  <InfoDetail>
                    {campAttributes["camp-accreditation"]}
                  </InfoDetail>
                </Info>
              </InfoColumn>
              <InfoColumn>
                <Info>
                  <InfoTitle>Camp enrollment</InfoTitle>
                  <InfoDetail>{campAttributes["camp-enrollment"]}</InfoDetail>
                </Info>
                <Info>
                  <InfoTitle>Camp age range</InfoTitle>
                  <InfoDetail>{campAttributes["camp-age-range"]}</InfoDetail>
                </Info>
                <Info>
                  <InfoTitle>Camp gender</InfoTitle>
                  <InfoDetail>{campAttributes["camp-gender"]}</InfoDetail>
                </Info>
              </InfoColumn>
            </Body>
          </CampInformation>
        </Segment>
        <Segment>
          <CampSpecialty>
            <Title>Camp Speciality</Title>
            {this.renderCampSpecialties(specialties)}
          </CampSpecialty>
        </Segment>
        <Segment>
          <CampExpertise>
            <Title>Camp Expertise</Title>
            {this.renderCampExpertises(expertises)}
          </CampExpertise>
        </Segment>
      </ActionWrapper>
    )
  }
}

export default CampProfileLoaded



// WEBPACK FOOTER //
// ./src/scenes/Camp/CampProfile/CampProfile.js